<template>
  <div class="page flex-col">
    <div class="group_1 flex-col justify-end">
      <!-- <div class="group_2 flex-row">
        <img
          class="image_1"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng5eb7835fc957042f4b02048930b15033b02aadc08574d830df2c060761b9879a.png"
        />
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4b858c76b9deb5b3941827f27d1c8ac1b586ba98eec1392060201b04c690af4c.png"
        />
        <span class="text_1">自由随心·Al随行·慧安智远</span>
        <span class="text_2" @click="PageIndex">首页</span>
        <span class="text_3" @click="sdycxq">产品方案</span>
        <span class="text_4" @click="case_presentation">案例展示</span>
        <span class="text_5" @click="news_information">新闻动态</span>
        <span class="text_6" @click="guanyuhuian">关于慧安</span>
      </div> -->

      <div class="group_2 flex-row items-center"> 
        <img class="image_1" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng5eb7835fc957042f4b02048930b15033b02aadc08574d830df2c060761b9879a.png" />
        <img class="image_2" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4b858c76b9deb5b3941827f27d1c8ac1b586ba98eec1392060201b04c690af4c.png" />
        <span class="text_1">自由随心·Al随行·慧安智远</span>
        <span class="text_2" @click="PageIndex">首页</span>

        <div class="dropdown-container" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
          <span class="text_4 cursor-pointer">产品方案</span>
          <div class="dropdown-menu" v-if="showDropdown">
            <div class="dropdown-item" @click="handleCaseClick('three_narcotic_drug_vehicle')">三代麻精药品车</div>
            <div class="dropdown-item" @click="handleCaseClick('two_narcotic_drug_vehicle')">二代麻精药品车</div>
            <div class="dropdown-item" @click="handleCaseClick('consumables_cabinet')">高值耗材柜</div>
            <div class="dropdown-item" @click="handleCaseClick('ai_recycling_bin')">AI智能回收箱</div>
            <div class="dropdown-item" @click="handleCaseClick('hydrogenperoxide_disinfection_machine')">过氧化氢消毒机</div>
            <div class="dropdown-item" @click="handleCaseClick('transfer_bed')">电动转运床</div>

          </div>
        </div>

        <span class="text_4" @click="case_presentation">案例展示</span>
        <span class="text_5" @click="news_information">新闻动态</span>
        <span class="text_6" @click="guanyuhuian">关于慧安</span>
      </div>

      <div class="group_3 flex-row">
        <div class="block_1 flex-col"></div>
      </div>
    </div>
    <div class="group_4 flex-row">
      <div class="text-group_1 flex-col justify-between">
        <span class="paragraph_1">
          慧安智远致力于：
          <br />
          让世界上每一支管控药都
          <br />
          数得清、用的清、记得清
          <br />
        </span>
        <span class="text_7">欢迎来到慧安智远，自由随心·Al随行·慧安智远</span>
      </div>
      <div class="block_2 flex-col">
        <div class="image-wrapper_1 flex-col">
          <!-- <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngb6c5deffc1f311cdddd63e85d64e542d21b9e228f754e03b5ec3511637a632c6.png"
          /> -->
        </div>
      </div>
      <div class="image-wrapper_2 flex-col">
        <img class="image_4" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng3cf61ce395c74f98272ed55b67d3e840760e740b739b579e3bf524065a09a976.png" />
      </div>
    </div>
    <div class="group_5 flex-col">
      <div class="box_1 flex-col">
        <div class="box_2 flex-row">
          <div class="text-wrapper_1 flex-col"><span class="text_8">我们的核心服务</span></div>
        </div>
        <div class="box_3 flex-row justify-between">
          <div class="group_6 flex-col justify-between">
            <div class="text-group_2 flex-col justify-between">
              <span class="text_9">高值耗材柜</span>
              <span class="text_10">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;和尔思高值耗材柜采用最新的RFID射频技术，通过标签自动识别耗材进出。存取耗材仅需两步，无需额外扫码动作，真正做到秒级响应。内设抽拉式存储抽屉和自定义隔板组件，各类型耗材均支持存放。系统支持接入医院HIS系统，拿出即绑定病人手术，一键收费。多样化生物登录方式，方便回溯。同时能够自动盘点、生成电子化台账，解放医护人员。耗材柜还支持多柜组网，支持医院SPD流程管理。高值耗材柜的初衷就是能够为手术室医护人员减轻管理压力，让高值耗材管理工作更轻松更高效。
              </span>
            </div>
            <div class="image-text_1 flex-row justify-between">
              <img class="label_1" referrerpolicy="no-referrer"
                src="./assets/img/SketchPng77ed9f1e1102bbd2722b7d573a002ed8e65b6e63b7642bb7cd8658d4166c29f6.png" />
              <div class="text-group_3 flex-col justify-between">
                <span class="text_11">RFID射频技术</span>
                <span class="text_12">超大空间存储</span>
                <span class="text_13">可扩展性强</span>
              </div>
            </div>
            <div class="image-text_2 flex-row justify-between">
              <img class="label_2" referrerpolicy="no-referrer"
                src="./assets/img/SketchPng77ed9f1e1102bbd2722b7d573a002ed8e65b6e63b7642bb7cd8658d4166c29f6.png" />
              <div class="text-group_4 flex-col justify-between">
                <span class="text_11">RFID射频技术</span>
                <span class="text_12">超大空间存储</span>
                <span class="text_13">可扩展性强</span>
              </div>
            </div>
            <div class="image-text_3 flex-row justify-between">
              <img class="label_3" referrerpolicy="no-referrer"
                src="./assets/img/SketchPng77ed9f1e1102bbd2722b7d573a002ed8e65b6e63b7642bb7cd8658d4166c29f6.png" />
              <div class="text-group_5 flex-col justify-between">
                <span class="text_11">RFID射频技术</span>
                <span class="text_12">超大空间存储</span>
                <span class="text_13">可扩展性强</span>
              </div>
            </div>
          </div>
          <div class="group_7 flex-col"></div>
        </div>
        <img class="image_5" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng29b88cf4425898ab742ae57e53ee4f6631ac3edf66ae68e5b7773292c150fc24.png" />
      </div>
     
    </div>
    <div class="group_8 flex-col">
      <div class="text-wrapper_8 flex-row">
        <span class="text_33">公司信息</span>
        <span class="text_34">二维码</span>
        <span class="text_35">商务合作</span>
      </div>
      <div class="image-wrapper_3 flex-row justify-between">
        <img class="image_6" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png" />
        <img class="image_7" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png" />
        <img class="image_8" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png" />
      </div>
      <div class="box_9 flex-row">
        <span class="paragraph_2">
          江苏慧安智远智能医疗科技有限公司
          <br />
          <br />
          地址：无锡市惠山区惠山大道1719-5号二层B区&nbsp;
          <br />
          电话：0510-83582015
          <br />
          邮箱：huianzhiyuan&#64;qq.com
          <br />
          官网：www.hilears.com&nbsp;
          <br />
        </span>
        <div class="image-text_4 flex-col justify-between">
          <div class="image-wrapper_4 flex-col">
            <img class="image_9" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6d89f0dbceb8cf2835772a0f780d8d18a85d8ad63f161fa6700239ef2ee1b0b1.png" />
          </div>
          <span class="text-group_10">
            关注公众号：HILEARS和尔思
            <br />
          </span>
        </div>
        <span class="text_36">卢先生&nbsp;&nbsp;0510-83582015</span>
      </div>
      <div class="text-wrapper_9 flex-row">
        <span class="text_37">
          Copyright&nbsp;©&nbsp;&nbsp;2025&nbsp;-&nbsp;forever&nbsp;&nbsp;江苏慧安智远智能医疗科技有限公司所有
          <a onclick="window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32020602001022')">苏公网安备
            32020602001022号&nbsp;&nbsp;</a>
          <a onclick="window.open('https://beian.miit.gov.cn')">苏ICP备20031743号-1</a>

        </span>
      </div>
    </div>
    <div class="group_9 flex-col">
      <div class="image-wrapper_5 flex-col">
        <img class="image_10" referrerpolicy="no-referrer"
          src="./assets/img/SketchPnga61ff6e8b54d05480d6b8c3078c36b6c55b0cfb6fb0b6cc7539ad71767f3e080.png" />
        <img class="image_11" referrerpolicy="no-referrer"
          src="./assets/img/SketchPnged2131b1729d0d270266b2120ecc43ab530cee0b31dff14946762f7014b1d78e.png" />
      </div>
      <img class="image_12" referrerpolicy="no-referrer"
        src="./assets/img/SketchPnge18ee852644e1fa15d7ca4c345f4f17ef08053e57cd03a6e9d47fe04eebef636.png" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 新增下拉菜单控制变量
      showDropdown: false,
      constants: {}
    };
  },
  methods: {
    // 新增下拉菜单点击处理方法
    handleCaseClick(type) {
      // 根据不同案例类型跳转到不同页面
      this.$router.push(`/${type}`);
      // 关闭下拉菜单
      this.showDropdown = false;
    },
    PageIndex() {
      this.$router.push('/PageIndex')
    },
    sdycxq() {
      this.$router.push('/three_narcotic_drug_vehicle')
    },
    guanyuhuian() {
      this.$router.push('/guanyuhuian')
    },
    case_presentation() {
      this.$router.push('/case_presentation')
    },
    news_information() {
      this.$router.push('/news_information')
    },
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style>
/* 修改下拉菜单样式 */
.dropdown-container {
  position: relative;
  display: inline-flex;
  /* 使用inline-flex保持与其他元素对齐 */
  align-items: center;
  /* 确保文本垂直居中 */
  height: 50%;
  /* 占满父容器高度 */
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  /* 从容器底部开始显示 */
  left: 0;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  min-width: 160px;
  z-index: 1000;
  margin-top: 5px;
  /* 与主菜单保持一点距离 */
  padding: 8px 0;
  animation: fadeIn 0.2s ease-in-out;
}

/* 调整菜单项样式 */
.dropdown-item {
  padding: 10px 16px;
  color: #1d1f24;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

/* 修复父容器对齐 */
.box_1 {
  align-items: center;
  /* 确保所有子元素垂直居中 */
  display: flex;
}

/* 保持其他样式不变 */
.text_4 {
  /* 确保文本本身垂直居中 */
  display: inline-flex;
  align-items: center;
  height: 100%;
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
